import { Filters } from '../../models/room-filter/filters.enum';
import { RoomFilter } from '../../models/room-filter/room-filter';
import { Injectable } from '@angular/core';

export type FilterBuilder = (order: number, key?: Filters, label?: string) => RoomFilter;

@Injectable({
  providedIn: 'root',
})
export class RoomFiltersConfig {
  private builders: Map<Filters, FilterBuilder> = new Map();
  public readonly FIlTER_ORDER: { [key in Filters]?: number };

  constructor() {
    let order = 1;
    this.FIlTER_ORDER = {
      [Filters.BREAKFAST]: order++,
      [Filters.ALL_INCLUSIVE]: order++,
      [Filters.HALF_BOARD]: order++,
      [Filters.FULL_BOARD]: order++,
      [Filters.PREPAID]: order++,
      [Filters.PREPAID_INTERNATIONAL]: order++,
      [Filters.PREPAID_NATIONAL]: order++,
      [Filters.PREPAID_USD]: order++,
      [Filters.REFUNDABLE]: order++,
      [Filters.PAY_AT_DESTINATION]: order++,
      [Filters.ROOM_ONLY]: order++,
      [Filters.NOT_REFUNDABLE]: order++,
      [Filters.DISNEY_MEALPLANS]: order++,
      [Filters.DISNEY_TICKETS]: order++,
      [Filters.DISNEY_ROOM_ONLY]: order++,
      [Filters.CONTRATO_DIRECTO]: order++,
    };

    this.builders.set(Filters.ROOM_ONLY, buildRoomOnly);
    this.builders.set(Filters.BREAKFAST, buildMealPlan);
    this.builders.set(Filters.ALL_INCLUSIVE, buildMealPlan);
    this.builders.set(Filters.HALF_BOARD, buildMealPlan);
    this.builders.set(Filters.FULL_BOARD, buildMealPlan);
    this.builders.set(Filters.PREPAID_USD, buildPrepaid);
    this.builders.set(Filters.PREPAID_NATIONAL, buildPrepaid);
    this.builders.set(Filters.PREPAID_INTERNATIONAL, buildPrepaid);
    this.builders.set(Filters.PAY_AT_DESTINATION, buildPayAtDestination);
    this.builders.set(Filters.REFUNDABLE, buildRefundable);
    this.builders.set(Filters.NOT_REFUNDABLE, buildNotRefundable);
    this.builders.set(Filters.DISNEY_MEALPLANS, buildDisneyFilter);
    this.builders.set(Filters.DISNEY_TICKETS, buildDisneyFilter);
    this.builders.set(Filters.DISNEY_ROOM_ONLY, buildDisneyFilter);
    this.builders.set(Filters.CONTRATO_DIRECTO, buildContratoDirecto);

    // ToDo: Filtros para disney
    // ToDo: parametrizar en un archivo los labels
  }

  public getBuilder(builderKey: Filters): FilterBuilder {
    if (!this.builders.has(builderKey)) {
      throw new Error(`Filter: ${builderKey} dont exist in the builder config.`);
    }
    return this.builders.get(builderKey);
  }
}

const buildRoomOnly: FilterBuilder = (order: number) => {
  return new RoomFilter('Solo habitación', Filters.ROOM_ONLY, order, []);
};

const buildMealPlan: FilterBuilder = (order: number, key: Filters, label: string) => {
  return new RoomFilter(label, key, order, []);
};

const buildPrepaid: FilterBuilder = (order: number, key: Filters) => {
  let label: string;
  switch (key) {
    case Filters.PREPAID_INTERNATIONAL:
      label = 'Pago en 1 cuota';
      break;
    case Filters.PREPAID_NATIONAL:
      label = 'Pago en cuotas';
      break;
    case Filters.PREPAID_USD:
      label = 'Pago en dólares';
      break;
  }
  return new RoomFilter(label, Filters.PREPAID, order, [Filters.PAY_AT_DESTINATION]);
};

const buildPayAtDestination: FilterBuilder = (order: number) => {
  return new RoomFilter('Pago en destino', Filters.PAY_AT_DESTINATION, order, [
    Filters.PREPAID_INTERNATIONAL,
    Filters.PREPAID_NATIONAL,
    Filters.PREPAID_USD,
  ]);
};

const buildRefundable: FilterBuilder = (order: number) => {
  return new RoomFilter('Cancelación gratuita', Filters.REFUNDABLE, order, [
    Filters.NOT_REFUNDABLE,
  ]);
};

const buildNotRefundable: FilterBuilder = (order: number) => {
  return new RoomFilter('No reembolsable', Filters.NOT_REFUNDABLE, order, [
    Filters.REFUNDABLE,
  ]);
};

const buildContratoDirecto: FilterBuilder = (order: number) => {
  return new RoomFilter('Contrato Directo', Filters.CONTRATO_DIRECTO, order, []);
};

const buildDisneyFilter: FilterBuilder = (order: number, key: Filters) => {
  let label;
  switch (key) {
    case Filters.DISNEY_MEALPLANS:
      label = 'Planes de comida';
      break;
    case Filters.DISNEY_TICKETS:
      label = 'Entradas a los parques';
      break;
    case Filters.DISNEY_ROOM_ONLY:
      label = 'Solo habitación';
      break;
  }
  return new RoomFilter(label, key, order, []);
};
